(function() {
  const _messagePreviewEl = document.querySelector('#gift-card-message');
  const _imagePreviewEl = document.querySelector('#gift-card-image');
  const _valuePreviewEl = document.querySelector('#gift-card-value');
  const _overlayEl = document.querySelector('.gift-card-preview-overlay');
  const _imageInputEl = document.querySelector('#gc-image');
  const _variantInputEl = document.querySelector('variant-selects select');

  const _init = function() {
    _bindMessageKeyUp();
    _bindPreviewLinkClick();
    _bindOverlayClick();
    _bindCloseButtonClick();
    _bindThumbnailClick();
    _updatePreviewValue();
    _bindVariantChange();
  }

  const _updatePreviewMessage = function(e) {
    _messagePreviewEl.innerHTML = e.target.value;
  }

  const _updatePreviewImage = function(e) {
    _imagePreviewEl.src = e.target.dataset.imageUrl;
    _imageInputEl.value = e.target.dataset.imageUrl;

    document.querySelectorAll('#gift-card-image-thumbnails img').forEach(function(imgElement) {
      imgElement.classList.remove('selected');
    });

    e.target.classList.add('selected');
  }

  const _getCurrentVariantValue = function() {
    return _variantInputEl.options[_variantInputEl.selectedIndex].value;
  }

  const _getDisplayValue = function(value) {
    return parseInt(value.replace('€', '')).toString() + ' €';
  }

  const _updatePreviewValue = function() {
    const displayValue = _getDisplayValue(_getCurrentVariantValue());
    _valuePreviewEl.innerHTML = displayValue;
  }

  const _showPreview = function(e) {
    document.body.classList.add('gift-card-preview-open');
  }

  const _hidePreview = function(e) {
    document.body.classList.remove('gift-card-preview-open');
  }

  const _bindMessageKeyUp = function() {
    document.querySelector('#gc-message').addEventListener('keyup', _updatePreviewMessage);
  }

  const _bindPreviewLinkClick = function() {
    document.querySelector('#gift-card-preview-link').addEventListener('click', _showPreview);
  }

  const _bindOverlayClick = function() {
    _overlayEl.addEventListener('click', _hidePreview);
  }

  const _bindCloseButtonClick = function() {
    document.querySelector('#gift-card-preview-close').addEventListener('click', _hidePreview);
  }

  const _bindThumbnailClick = function() {
    document.querySelectorAll('#gift-card-image-thumbnails img').forEach(function(imgElement) {
      imgElement.addEventListener('click', _updatePreviewImage);
    });
  }

  const _bindVariantChange = function() {
    _variantInputEl.addEventListener('change', _updatePreviewValue);
  }

  _init();
})();
